module.exports = __webpack_public_path__ + "static/media/79_441f5ce3_1_.1c02b4bb.jpg";